import DomainSelectorController from './domain-selector.controller';

require('./domain-selector.scss');

const DomainSelectorComponent = {
    selector: 'sbDomainSelector',
    controller: DomainSelectorController,
    template: require('./domain-selector.html'),
    bindings: {
        onSelect: '&',
    },
};

export default DomainSelectorComponent;



// WEBPACK FOOTER //
// ./src/app/components/domain-selector/index.js